import { Injectable } from '@angular/core';
import { ThemeEntryDto } from '@osos/shared/api';
import { ThemePresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases';

@Injectable({
  providedIn: 'root',
})
export class ThemeParserV1Service extends ParserBase<
  ThemeEntryDto,
  ThemePresenterModel
> {
  constructor() {
    super(ThemeEntryDto, ThemePresenterModel, 1);
  }
  override getPresenterModel(
    model: Partial<ThemeEntryDto>,
  ): ThemePresenterModel {
    return {
      dark_colors_mobile_customization: model.dark_colors_mobile_customization,
      dark_mode: model.dark_mode,
      general_css: model.general_css,
      id: model.id,
      light_colors_mobile_customization:
        model.light_colors_mobile_customization,
      theme_name: model.theme_name,
      used_font: model.used_font,
    } as unknown as ThemePresenterModel;
  }
  override getDataModel(presenter: ThemePresenterModel): ThemeEntryDto {
    return {
      dark_colors_mobile_customization:
        presenter.dark_colors_mobile_customization,
      dark_mode: presenter.dark_mode,
      general_css: presenter.general_css,
      id: presenter.id,
      light_colors_mobile_customization:
        presenter.light_colors_mobile_customization,
      theme_name: presenter.theme_name,
      used_font: presenter.used_font,
    } as unknown as ThemeEntryDto;
  }
}
